import { KYBER_API } from '../api/endpoints'
import { KyberServer } from '../api/models'

export const FAKE_RESPONSE: KyberServer[] = [
  {
    id: '34084f9783e3c0c14de3bbd7a0640a0a',
    name: 'Rework + padme/ventress (1)',
    description: 'Massive PM/IA mods ',
    map: 'S7_2/Levels/Naboo_03/Naboo_03',
    mode: 'Mode1',
    mods: [
      { name: 'PM/IA Battlefront Gameplay Rework (1.4.3)' },
      { name: 'PM/IA Airborne Trooper Reinforcement (1.0)' },
      { name: 'PM/IA Clone Engineer (1.4)' },
      { name: 'PM/IA Republic Gunner Reinforcement V4 (4.0)' },
      { name: 'PM/IA Mangaguard Staff V3 (3.0)' },
      { name: 'PM/IA Magnaguard Reinforcement V2 (2.0)' },
      { name: 'PM/IA Honor Guard Reinforcement V4 (4.0)' },
      { name: 'PM/IA Rebel Commando (1.0)' },
      { name: 'PM/IA Rebel Saboteur (1.5)' },
      { name: 'PM/IA Purge Trooper Commander by EldeBH (0.8)' },
      { name: 'PM/IA Royal Guard Reinforcement - Cape Addon (1.0.4)' },
      { name: 'PM/IA Royal Guard Reinforcement (1.0.4)' },
      { name: 'PM/IA Shock Trooper Reinforcement V3 (3.0)' },
      { name: 'PM/IA Viper Probe Droid (0.15)' },
      { name: 'PM/IA Nikto Smuggler (0.9)' },
      { name: 'PM/IA Stormtrooper Commander (0.8)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo - Head Mesh (0.27)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo (0.27)' },
      { name: 'PM/IA Captain Rex - Skirt Mesh (0.06)' },
      { name: 'PM/IA Captain Rex (0.23)' },
      { name: 'PM/IA Jango Fett by DeggialNox (0.23)' },
      { name: 'PM/IA Dengar (0.17)' },
      { name: 'PM/IA Din Djarin - "The Mandalorian" by AlexPo (1.38)' },
      { name: 'PM/IA Commander Pyre (0.19)' },
      { name: 'PM/IA PadmC) Amidala V1.2 (1.2)' },
      { name: 'PM IA Ventress V2 (1.1)' },
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
      { name: 'IOI Addon - Ewok Village Blast Improved (1.0)' },
    ],
    users: 11,
    host: '-GF-Azura',
    maxPlayers: 40,
    autoBalanceTeams: true,
    startedAt: 1643775650372,
    startedAtPretty: '2h ago',
    requiresPassword: false,
    region: 'BETA',
    proxy: {
      ip: '165.232.149.242',
      name: 'San Francisco - US',
      flag: `${KYBER_API.hostName}/static/images/flags/us.svg`,
    },
  },
  {
    id: '595acc431efe00f5ebcc181b7dd9c6ec',
    name: 'BF 1V1S',
    map: 'S8/Felucia/Levels/MP/Felucia_01/Felucia_01',
    mode: 'HeroesVersusVillains',
    mods: [
      { name: 'PM/IA Battlefront Gameplay Rework (1.4.3)' },
      { name: 'PM/IA Airborne Trooper Reinforcement (1.0)' },
      { name: 'PM/IA Clone Engineer (1.4)' },
      { name: 'PM/IA Republic Gunner Reinforcement V4 (4.0)' },
      { name: 'PM/IA Mangaguard Staff V3 (3.0)' },
      { name: 'PM/IA Magnaguard Reinforcement V2 (2.0)' },
      { name: 'PM/IA Honor Guard Reinforcement V4 (4.0)' },
      { name: 'PM/IA Rebel Commando (1.0)' },
      { name: 'PM/IA Rebel Saboteur (1.5)' },
      { name: 'PM/IA Purge Trooper Commander by EldeBH (0.8)' },
      { name: 'PM/IA Royal Guard Reinforcement - Cape Addon (1.0.4)' },
      { name: 'PM/IA Royal Guard Reinforcement (1.0.4)' },
      { name: 'PM/IA Shock Trooper Reinforcement V3 (3.0)' },
      { name: 'PM/IA Viper Probe Droid (0.15)' },
      { name: 'PM/IA Nikto Smuggler (0.9)' },
      { name: 'PM/IA Stormtrooper Commander (0.8)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo - Head Mesh (0.27)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo (0.27)' },
      { name: 'PM/IA Captain Rex - Skirt Mesh (0.06)' },
      { name: 'PM/IA Captain Rex (0.23)' },
      { name: 'PM/IA Jango Fett by DeggialNox (0.23)' },
      { name: 'PM/IA Dengar (0.17)' },
      { name: 'PM/IA Din Djarin - "The Mandalorian" by AlexPo (1.38)' },
      { name: 'PM/IA Commander Pyre (0.19)' },
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
      { name: 'IOI Addon - Ewok Village Blast Improved (1.0)' },
    ],
    users: 8,
    host: 'billedbrush3',
    maxPlayers: 40,
    autoBalanceTeams: true,
    startedAt: 1643766193373,
    startedAtPretty: '4h ago',
    requiresPassword: false,
    region: 'BETA',
    proxy: {
      ip: '167.99.178.133',
      name: 'Toronto - Canada',
      flag: `${KYBER_API.hostName}/static/images/flags/ca.svg`,
    },
  },
  {
    id: '3832a9b0273dd57030eb223876505bf3',
    name: 'Star Fight of the Fights',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    map: 'Levels/Space/SB_Endor_01/SB_Endor_01',
    mode: 'Mode7',
    mods: [
      { name: 'IOI Addon - Cross Era Heroes in Supremacy and COOP (1.0)' },
      { name: 'PM/IA Battlefront Gameplay Rework (1.4.3)' },
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
      { name: 'Create Your Hero 1.2 (1.2)' },
      { name: 'PM/IA Captain Rex - Skirt Mesh (0.06)' },
      { name: 'PM/IA Captain Rex (0.23)' },
      { name: 'PM/IA PadmC) Amidala V1.2 (1.2)' },
      { name: 'PM/IA Dengar (0.17)' },
      { name: 'PM/IA Jango Fett by DeggialNox (0.23)' },
      { name: 'PM/IA Mangaguard Staff V3 (3.0)' },
      { name: 'PM/IA Magnaguard Reinforcement V2 (2.0)' },
      { name: 'PM IA Jedi Knight (0.3)' },
    ],
    users: 2,
    host: 'Wizardy_Pikachu',
    maxPlayers: 40,
    autoBalanceTeams: false,
    startedAt: 1643783456747,
    startedAtPretty: '2m ago',
    requiresPassword: false,
    region: 'BETA',
    proxy: {
      ip: '178.62.116.145',
      name: 'London - UK',
      flag: `${KYBER_API.hostName}/static/images/flags/gb.svg`,
    },
  },
  {
    id: 'b2d7e62bfded3d6f00b77015d200622a',
    name: 'autism',
    map: 'S2/Levels/CloudCity_01/CloudCity_01',
    mode: 'HeroesVersusVillains',
    mods: [
      { name: 'IOI Addon - No Boundaries (1.0)' },
      { name: 'IOI Addon - No Kitlimitations (1.0)' },
      { name: 'IOI Addon - Heroes Unrestricted (1.0)' },
      { name: 'IOI Addon - Cross Era Heroes in Supremacy and COOP (1.0)' },
      { name: 'IOI Addon - Regular HvsV (1.0)' },
      { name: 'IOI Addon - Clone Wars All Maps V2 (2.0)' },
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
    ],
    users: 2,
    host: 'NotBraun',
    maxPlayers: 64,
    autoBalanceTeams: true,
    startedAt: 1643780874488,
    startedAtPretty: '45m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '167.99.178.133',
      name: 'Toronto - Canada',
      flag: `${KYBER_API.hostName}/static/images/flags/ca.svg`,
    },
  },
  {
    id: '34165a2f4f4554077b48a84e08747e8e',
    name: 'whato',
    map: 'Levels/MP/Hoth_01/Hoth_01',
    mode: 'Mode9',
    mods: [],
    users: 1,
    host: 'SnowelIe',
    maxPlayers: 4,
    autoBalanceTeams: true,
    startedAt: 1643782591323,
    startedAtPretty: '17m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '207.154.197.74',
      name: 'Frankfurt - Germany',
      flag: `${KYBER_API.hostName}/static/images/flags/de.svg`,
    },
  },
  {
    id: 'df67d4eee55f8e9e4933a6f0c8cb7f1e',
    name: '1234',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    map: 'S1/Levels/Crait_01/Crait_01',
    mode: 'PlanetaryBattles',
    mods: [
      { name: 'IOI Addon - Clone Wars All Maps V2 (2.0)' },
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
      { name: 'IOI Addon - Ewok Village Blast Improved (1.0)' },
      { name: 'IOI Addon - No Boundaries (1.0)' },
      { name: 'IOI Addon - No Kitlimitations (1.0)' },
      { name: 'IOI Addon - Heroes Unrestricted (1.0)' },
    ],
    users: 1,
    host: 'zethanox',
    maxPlayers: 40,
    autoBalanceTeams: false,
    startedAt: 1643782940052,
    startedAtPretty: '11m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '188.166.209.46',
      name: 'Singapore - Asia',
      flag: `${KYBER_API.hostName}/static/images/flags/sg.svg`,
    },
  },
  {
    id: 'a53f74f2757d5cb44d38c482539d2fae',
    name: 'yeye',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras et tempor magna. Sed vulputate, lorem vitae vehicula semper, neque lacus suscipit magna, et aliquet leo lacus eu dui.',
    map: 'Levels/MP/Naboo_02/Naboo_02',
    mode: 'HeroesVersusVillains',
    mods: [
      { name: 'IOI - Instant Online Improvements V4 (4.0)' },
      { name: 'IOI Addon - Heroes Unrestricted (1.0)' },
      { name: 'PM IA Ventress V2 (1.1)' },
      { name: 'PM IA Pre Vizla V2 (1)' },
      { name: 'PM/IA Greedo (1.0)' },
      { name: 'PM/IA PadmC) Amidala (1.1)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo - Head Mesh (0.27)' },
      { name: 'PM/IA Ahsoka Tano by Mandalo (0.27)' },
      { name: 'PM/IA Captain Rex - Skirt Mesh (0.06)' },
      { name: 'PM/IA Captain Rex (0.23)' },
      { name: 'PM/IA Din Djarin - "The Mandalorian" by AlexPo (1.38)' },
    ],
    users: 1,
    host: 'Dave-Swampwalker',
    maxPlayers: 3,
    autoBalanceTeams: false,
    startedAt: 1643783114522,
    startedAtPretty: '8m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '45.76.117.215',
      name: 'Sydney - Australia',
      flag: `${KYBER_API.hostName}/static/images/flags/au.svg`,
    },
  },
  {
    id: 'e61fc24a8c7d84d81fff04a31c974325',
    name: '2313',
    map: 'S7_2/Levels/Naboo_03/Naboo_03',
    mode: 'Mode1',
    mods: [{ name: 'IOI - Instant Online Improvements V4 (4.0)' }],
    users: 1,
    host: 'Nareiik',
    maxPlayers: 64,
    autoBalanceTeams: true,
    startedAt: 1643783235111,
    startedAtPretty: '6m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '165.232.149.242',
      name: 'San Francisco - US',
      flag: `${KYBER_API.hostName}/static/images/flags/us.svg`,
    },
  },
  {
    id: '7f4fc4dbf554f71ffcfdfc1da9d70d5c',
    name: 'dwagr',
    map: 'Levels/MP/DeathStar02_01/DeathStar02_01',
    mode: 'HeroesVersusVillains',
    mods: [{ name: 'IOI - Instant Online Improvements V4 (4.0)' }],
    users: 1,
    host: 'AgentR0x',
    maxPlayers: 40,
    autoBalanceTeams: false,
    startedAt: 1643783547090,
    startedAtPretty: '1m ago',
    requiresPassword: true,
    region: 'BETA',
    proxy: {
      ip: '207.154.197.74',
      name: 'Frankfurt - Germany',
      flag: `${KYBER_API.hostName}/static/images/flags/de.svg`,
    },
  },
]